import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Discipline() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [disciplines, setDisciplines] = useState({});

  const location = useLocation();

  const memberId = location.pathname.split('/')[2];

  useEffect(() => {
    const fetchDisciplines = async () => {
      try {
        const res = await axios.get(
          `https://databasebackend.ecz.co.zw/disciplines/${memberId}`
        );
        setDisciplines(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDisciplines();
  }, [memberId]);

  return (
    <div className="member">
      <div className="memberTitleContainer">
        <h1 className="memberTitle">Discipline Details</h1>
        <Link to={'/edit-discipline/' + memberId}>
          <button className="memberAddButton">Edit</button>
        </Link>
      </div>
      <div className="memberContainer">
        <div className="memberShow">
          <div className="memberShowBottom">
            <div className="memberShowInfo">
              <span className="memberShowInfoLabel">Name:</span>{' '}
              <span className="memberShowInfoTitle">
                {disciplines.discipline}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
